export default "__VITE_ASSET__CaGgHaa0__"